export const setSelectedGlobalCountry = (data: any) => ({
    type: "SET_SELECTED_GLOBAL_COUNTRY",
    payload: data,
  });
  